// 近30天模块用量趋势 mock 数据
// 每个模块包含30天的每日用量数据

function genTrend(
  base: number,
  variance: number,
  trend: 'up' | 'down' | 'flat' | 'spike',
  days = 30
): number[] {
  const result: number[] = [];
  let cur = base;
  for (let i = 0; i < days; i++) {
    const noise = (Math.random() - 0.5) * variance;
    if (trend === 'up') cur += base * 0.015 + noise;
    else if (trend === 'down') cur -= base * 0.01 + noise;
    else if (trend === 'spike' && (i === 10 || i === 22)) cur += base * 0.6;
    else cur += noise;
    result.push(Math.max(0, Math.round(cur)));
  }
  return result;
}

// 生成最近30天的日期标签
export const TREND_DATES: string[] = Array.from({ length: 30 }, (_, i) => {
  const d = new Date('2026-04-01');
  d.setDate(d.getDate() - (29 - i));
  return `${d.getMonth() + 1}/${d.getDate()}`;
});

export const MODULE_USAGE_TREND: Record<string, {
  daily: number[];
  unit: string;
  peak: number;
  avg: number;
  mom: number; // 月环比 %
  trend: 'up' | 'down' | 'flat' | 'spike';
  color: string;
}> = {
  employees: {
    daily: [42,45,43,48,50,47,52,55,53,58,60,57,62,65,63,68,70,67,72,75,73,78,80,77,82,85,83,88,90,87],
    unit: '次对话',
    peak: 90,
    avg: 67,
    mom: 18,
    trend: 'up',
    color: '#8b5cf6',
  },
  crm: {
    daily: [120,135,128,142,150,138,155,162,158,168,175,170,180,188,182,192,198,195,205,212,208,218,225,220,230,238,232,242,248,245],
    unit: '条操作',
    peak: 248,
    avg: 186,
    mom: 22,
    trend: 'up',
    color: '#f59e0b',
  },
  collab: {
    daily: [85,88,82,90,92,87,94,96,91,98,100,95,102,104,99,106,108,103,110,112,107,114,116,111,118,120,115,122,124,119],
    unit: '次协作',
    peak: 124,
    avg: 103,
    mom: 12,
    trend: 'up',
    color: '#0ea5e9',
  },
  knowledge: {
    daily: [3200,3400,3100,3600,3800,3500,3900,4100,3800,4200,4400,4100,4500,4700,4400,4800,5000,4700,5100,5300,5000,5400,5600,5300,5700,5900,5600,6000,6200,5900],
    unit: 'Tokens',
    peak: 6200,
    avg: 4680,
    mom: 28,
    trend: 'up',
    color: '#10b981',
  },
  workflow: {
    daily: [88,92,85,96,100,93,104,108,101,112,116,109,120,124,117,128,132,125,136,140,133,144,148,141,152,156,149,160,164,157],
    unit: '次执行',
    peak: 164,
    avg: 124,
    mom: 15,
    trend: 'up',
    color: '#6366f1',
  },
  engine: {
    daily: [520,540,510,560,580,550,590,610,580,620,640,610,650,670,640,680,700,670,710,730,700,740,760,730,770,790,760,800,820,790],
    unit: '次调用',
    peak: 820,
    avg: 672,
    mom: 20,
    trend: 'up',
    color: '#64748b',
  },
  office: {
    daily: [12,14,11,15,16,13,17,18,14,19,20,16,21,22,17,23,24,18,25,26,19,27,28,20,29,30,21,31,32,22],
    unit: '次访问',
    peak: 32,
    avg: 21,
    mom: 8,
    trend: 'up',
    color: '#94a3b8',
  },
  workbench: {
    daily: [45,48,43,50,52,47,54,56,51,58,60,55,62,64,59,66,68,63,70,72,67,74,76,71,78,80,75,82,84,79],
    unit: '次访问',
    peak: 84,
    avg: 64,
    mom: 10,
    trend: 'up',
    color: '#0ea5e9',
  },
  reports: {
    daily: [8,9,7,10,11,8,12,13,9,14,15,10,16,17,11,18,19,12,20,21,13,22,23,14,24,25,15,26,27,16],
    unit: '份报告',
    peak: 27,
    avg: 15,
    mom: 35,
    trend: 'up',
    color: '#f97316',
  },
  lead: {
    daily: [280,310,265,340,380,320,420,460,390,500,540,470,580,620,550,660,700,630,740,780,710,820,860,790,900,940,870,980,1020,950],
    unit: '条客资',
    peak: 1020,
    avg: 638,
    mom: 42,
    trend: 'up',
    color: '#f59e0b',
  },
  msghub: {
    daily: [1200,1350,1180,1420,1500,1380,1560,1640,1520,1700,1780,1660,1840,1920,1800,1980,2060,1940,2120,2200,2080,2260,2340,2220,2400,2480,2360,2540,2620,2500],
    unit: '条消息',
    peak: 2620,
    avg: 1924,
    mom: 38,
    trend: 'up',
    color: '#0ea5e9',
  },
  privatedomain: {
    daily: [42,38,45,35,50,40,55,48,52,44,58,50,62,54,60,56,65,58,68,62,66,70,64,72,68,75,70,78,72,80],
    unit: '次互动',
    peak: 80,
    avg: 59,
    mom: 16,
    trend: 'up',
    color: '#10b981',
  },
  outbound: {
    daily: [520,480,560,440,600,500,640,580,620,540,680,620,720,660,700,640,760,700,800,740,780,720,840,780,860,800,820,760,880,840],
    unit: '分钟',
    peak: 880,
    avg: 692,
    mom: 8,
    trend: 'spike',
    color: '#ef4444',
  },
  shortvideogen: {
    daily: [1,2,1,3,2,1,4,3,2,5,4,3,6,5,4,7,6,5,8,7,6,9,8,7,10,9,8,11,10,9],
    unit: '条视频',
    peak: 11,
    avg: 5,
    mom: 55,
    trend: 'up',
    color: '#db2777',
  },
  videoedit: {
    daily: [3,4,3,5,4,3,6,5,4,7,6,5,8,7,6,9,8,7,10,9,8,11,10,9,12,11,10,13,12,11],
    unit: '个任务',
    peak: 13,
    avg: 7,
    mom: 48,
    trend: 'up',
    color: '#7c3aed',
  },
  videomatrix: {
    daily: [8,10,7,12,11,9,14,13,10,16,15,12,18,17,14,20,19,16,22,21,18,24,23,20,26,25,22,28,27,24],
    unit: '条发布',
    peak: 28,
    avg: 17,
    mom: 32,
    trend: 'up',
    color: '#6366f1',
  },
  livestream: {
    daily: [0,1,0,2,1,0,3,2,1,4,3,2,5,4,3,6,5,4,7,6,5,8,7,6,9,8,7,10,9,8],
    unit: '场直播',
    peak: 10,
    avg: 4,
    mom: 60,
    trend: 'up',
    color: '#f97316',
  },
  geo: {
    daily: [2,3,2,4,3,2,5,4,3,6,5,4,7,6,5,8,7,6,9,8,7,10,9,8,11,10,9,12,11,10],
    unit: '篇文章',
    peak: 12,
    avg: 6,
    mom: 45,
    trend: 'up',
    color: '#64748b',
  },
};
